const RECEIVE_ALL_OMNI_SUBCATEGORIES = 'src/omniBrands/RECEIVE_ALL_OMNI_SUBCATEGORIES' as const;

export default { RECEIVE_ALL_OMNI_SUBCATEGORIES };
